import API from '@/api/index';

const maintenance = {
  state: {
    maintenances: [],
  },

  mutations: {
    SET_MAINTENANCES: (state, list) => {
      state.maintenances = list;
    },
  },

  actions: {
    getMaintenances ({ commit }) {
      return new Promise((resolve, reject) => {
        API.maintenance.getMaintenances().then(response => {
          let result = response.data;
          if (!result.code) {
            commit('SET_MAINTENANCES', result.data || []);
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    createMaintenance ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.maintenance.createMaintenance(data).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    updateMaintenance ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.maintenance.updateMaintenance(data).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    deleteMaintenance ({ commit }, id) {
      return new Promise((resolve, reject) => {
        API.maintenance.deleteMaintenance(id).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    executeMaintenance ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.maintenance.executeMaintenance(data).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    getMaintenanceDetail ({ commit }, id) {
      return new Promise((resolve, reject) => {
        API.maintenance.getMaintenanceDetail(id).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    getMaintenanceHistory ({ commit }, vehicleId) {
      return new Promise((resolve, reject) => {
        API.maintenance.getMaintenanceHistory(vehicleId).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    calculateKmRemain ({ commit }, params) {
      return new Promise((resolve, reject) => {
        API.maintenance.calculateKmRemain(params).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    createMaintenanceType ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.maintenance.createMaintenanceType(data).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    getMaintenanceTypes ({ commit }, params) {
      return new Promise((resolve, reject) => {
        API.maintenance.getMaintenanceTypes(params).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

  }
};

export default maintenance;


// WEBPACK FOOTER //
// ./src/store/modules/maintenance.js